// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"e8feefe1","694":"626037dd"}[chunkId] + ".chunk.js";
};